import mailValidator from "email-validator";

export const isValidMail = (mail) =>{
    return mailValidator.validate(mail)
}